import { useEffect, useState } from "react";
import { ModalBase } from "../../../components/Modals/ModalBase";
import { REGEX_EMAIL } from "../../../constants/Regex";
import BackIcon from '../../../media/felsv/dark_left-arrow_icon.svg'
import NextIcon from '../../../media/felsv/white_right-arrow_icon.svg'
import InputChips from "./InputChips";
import { unirChipsJoin } from "../../../utils/strings.utils";

export default function ModalSendEmailDTE ({onClickBack, onClickSend, defaultEmail, chipsEmail} : {onClickBack: () => void, onClickSend: (email: string) => void, defaultEmail?: string, chipsEmail?: Array<string>}){
    const [chipsEmails, setChipsEmails] = useState(chipsEmail)
    const [email, setEmail] = useState(defaultEmail ?? '');
    const [error, setError] = useState('')

    useEffect(() => {
        if (email.trim() !== "") {
            if(!REGEX_EMAIL.test(email.trim())){
                setError('Correo electrónico inválido')
            } else {
                setError('')
            }
        }
    }, [email])

    const handleSend = () => {
        if (error === '') {
            onClickSend(unirChipsJoin(chipsEmails ?? [], email));
        }
    }

    return (
        <ModalBase>
            <div className="dte-send-email-container">
                <div>
                    <h3 className="card-title">Enviar por correo</h3>
                </div>
                <div className="separador"/>
                <InputChips 
                    maxChips={5} chips={chipsEmails} setChips={setChipsEmails} maxLength={50} 
                    required name='email' placeholder='Correo electrónico' label='Correo electrónico' type='text'
                    onChange={(e: any) => setEmail(e.target.value)} value={email}
                    error={error}
                />
                <div className="dte-send-email-footer">
                    <button onClick={onClickBack} className="button transparent w-inline-block">
                        <img alt="back" src={BackIcon}/>
                        Regresar
                    </button>
                    <button onClick={handleSend} className="button w-inline-block">
                        Enviar
                        <img alt="next" src={NextIcon}/>
                    </button>
                </div>
            </div>
        </ModalBase>
    )
}